// @flow
import React, { Component } from 'react';
import LetteringLetterCards from 'containers/list/LetteringLetterCards';
import LetteringTemplate from 'components/lettering/LetteringTemplate/LetteringTemplate';
import ScrollToTop from 'components/common/ScrollToTop';
import { Helmet } from 'react-helmet';
import type { ContextRouter } from 'react-router-dom';
import queryString from 'query-string';

type Props = {} & ContextRouter;

class Lettering extends Component<Props> {
  render() {
    const { location, match, history } = this.props;
    const { sort } = queryString.parse(location.search);
    const { category } = match.params;
    return (
      <LetteringTemplate>
        <Helmet>
          <title>바이오위클리 | 캐시바이</title>
          <meta
            name="description"
            content="캐시바이에 방금 등록된 따끈따끈한 뉴스레터들을 살펴보세요."
          />
        </Helmet>
        <LetteringLetterCards category={category} sort={sort} />
      </LetteringTemplate>
    );
  }
}

export default Lettering;



// WEBPACK FOOTER //
// ./src/pages/Lettering.js